import React from 'react';
import { ProfilePicture } from '@getro/rombo';
import { Flex, Box, Text, Link } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { sortPositionsByCompany } from '../../../../../services/contacts/postitions';
import { CompanyInfo } from '../../companyInfo';
import { ContactInfoWorkDate } from '../../contactInfoWorkDate';
import { EnrichmentButton } from '../../enrichmentButton';

export const Experience = ({ pastPositions, skills, contact, networkId, list, type }) => {
  const sortedPastPositions = sortPositionsByCompany(pastPositions);

  if (contact?.enrichmentStatus !== 'enriched' && type !== 'public') {
    return (
      <Box sx={{ padding: '16px', borderRadius: '4px', backgroundColor: 'neutral.20' }}>
        <EnrichmentButton contact={contact} networkId={networkId} isList={Boolean(list?.id)} isContactDetail />
      </Box>
    );
  }

  return (
    <>
      {sortedPastPositions?.length ? (
        <Flex mt="8px" flexDirection="column" sx={{ gap: '32px' }}>
          {sortedPastPositions.map((companyPositions) => (
            <Flex
              key={`past-experience-dv-${companyPositions[0].companyName}-${companyPositions[0].companyLinkedinUrl}`}
            >
              <Box mr="2" flex="0 0 auto" width="32px" height="32px">
                {companyPositions[0].companyLinkedinUrl ? (
                  <Link
                    href={companyPositions[0].companyLinkedinUrl}
                    sx={{ textDecoration: 'none', ':hover': { textDecoration: 'underline' } }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ProfilePicture
                      name={companyPositions[0].companyName || ''}
                      variant="square"
                      imageUrl={companyPositions[0].logoUrl}
                    />
                  </Link>
                ) : (
                  <ProfilePicture
                    name={companyPositions[0].companyName || ''}
                    variant="square"
                    imageUrl={companyPositions[0].logoUrl}
                  />
                )}
              </Box>
              {companyPositions.length === 1 && (
                <Box>
                  <Text fontSize="14px" fontWeight="medium" color="text.dark">
                    {companyPositions[0].jobTitle}
                  </Text>
                  <CompanyInfo position={companyPositions[0]} />
                  {companyPositions[0].dateFrom && <ContactInfoWorkDate mt="4px" position={companyPositions[0]} />}
                </Box>
              )}
              {companyPositions.length !== 1 && (
                <Box>
                  <Flex alignItems="center" sx={{ gap: '8px' }}>
                    <CompanyInfo position={companyPositions[0]} />
                  </Flex>
                  {companyPositions.map((pos, index) => (
                    <Box
                      mt={index === 0 ? '8px' : '4px'}
                      key={`past-experience-dv-${companyPositions[0].companyName}-${pos.jobTitle}`}
                    >
                      <Text fontSize="1" fontWeight="medium" color="text.dark">
                        {pos.jobTitle}
                      </Text>
                      {pos.dateFrom && <ContactInfoWorkDate position={pos} />}
                    </Box>
                  ))}
                </Box>
              )}
            </Flex>
          ))}
        </Flex>
      ) : (
        <Text mt="3" fontSize="1" color="text.subtle" fontStyle="italic">
          No current or past roles found on this contact’s LinkedIn profile.
        </Text>
      )}
      <Text
        mt="40px"
        fontSize="0"
        fontWeight="medium"
        color="text.subtle"
        sx={{ textTransform: 'uppercase', letterSpacing: '1px' }}
      >
        Skills
      </Text>
      {skills?.length ? (
        <Text mt="3" fontSize="1" lineHeight="24px" sx={{ textTransform: 'capitalize' }}>
          {skills.join(', ')}
        </Text>
      ) : (
        <Text mt="3" fontSize="1" color="text.subtle" fontStyle="italic">
          No skills found on this contact’s LinkedIn profile.
        </Text>
      )}
    </>
  );
};

Experience.propTypes = {
  pastPositions: PropTypes.array,
  skills: PropTypes.array,
  contact: PropTypes.object,
  networkId: PropTypes.string,
  list: PropTypes.object,
  type: PropTypes.string,
};

Experience.defaultProps = {
  pastPositions: [],
  skills: [],
  contact: {},
  networkId: '',
  list: {},
  type: '',
};
